import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  public static KEYS: any = {
    clientId: '*&^%&%frgter^87i5',
    clientSecret: 'V%$#reg%786v*7i6',
    accessToken: 'B57UB5&ehyr&5b&*6',
    refreshToken: 'INB*gege&U4^345%36^5u',
    authorities: 'BUegeg&v3$76u%^&*',
    phone: 'phone',
    name: 'name',
    email: 'email',
    id: 'id',
    username: 'username',
    jti: 'Jjjsdb!*(&*@&#*&Y#',
  };

  static put(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static retrieve(key: string) {
    return localStorage.getItem(key);
  }

  static remove(key: string){
    localStorage.removeItem(key)
  }

  static retrieveAsync(
    key: string,
    fn: (data: string | null) => void,
    err: (any: any) => void = () => {
    }) {
    LocalStorageService.getFromLocalStorageAsync(key)
      .then(data => {
        fn(data as (string | null))
      })
      .catch(error => {
        err(error)
      });
  }

  static clear(): void {
    localStorage.clear();
  }

  static getFromLocalStorageAsync(key: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => { // Simulate asynchronous operation
        try {
          const data = localStorage.getItem(key);
          resolve(data);
        } catch (error) {
          reject(error);
        }
      }, 0); // Set timeout to 0 to avoid blocking the main thread
    });
  }

}
